import { call, debounce, put, select } from 'redux-saga/effects';

import { DEBOUNCE_TIME } from 'constants/Global';
import { PATH } from 'constants/RoutesConstants';

import { scopeToPage } from 'modules/app/sagas/utils';
import { fetchLeads } from 'modules/leads/actions/core';
import * as actionTypes from 'modules/leads/actionTypes';
import { getParams } from 'modules/leads/selectors/intervention';
import { LeadsTarget } from 'modules/leads/types';

/** Fetches the first page of the intervention leads panel for the selected intervention. */
export function* refreshInterventionLeads() {
  const params: ReturnType<typeof getParams> = yield select(getParams);
  yield put(fetchLeads({ ...params, page: 0 }, { target: LeadsTarget.INTERVENTION }));
}

function* onInterventionWorker() {
  yield debounce(DEBOUNCE_TIME, actionTypes.SET_INTERVENTION_FILTERS, refreshInterventionLeads);
}

export default function* interventionLeadsSaga() {
  yield call(scopeToPage, [PATH.SALES_DETAILED], onInterventionWorker);
}
